import React, { Fragment } from 'react';

import useMemberAdministrationSelection from './UseMemberAdministrationSelection';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

const MemberAdministrationSelection = () => {
  const {
    isLoading
  } = useMemberAdministrationSelection();

  return (
    <Fragment>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default MemberAdministrationSelection;